// extracted by mini-css-extract-plugin
export default {"header":"header---NBROx","widgetTitle":"widgetTitle---HHvbu"};